module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23 14.167h-4v-6h-6v6H9l7 7 7-7zm-14 9v2h14v-2H9z\"></path></svg>"